import React, {useEffect, useState} from 'react';
import {getApi} from "../../../apis/backendApis";
import CIcon from '@coreui/icons-react';
import "./Styles.scss";
import {
    CButton,
    CCard,
    CCardBody,
    CCol,
    CCollapse, CInput,
    CModal,
    CModalBody,
    CModalHeader,
    CModalTitle, CNav, CNavItem, CNavLink,
    CRow, CSelect, CTabContent, CTabPane, CTabs
} from "@coreui/react";
import {Bar} from 'react-chartjs-2';
import {
    dataBaseSprint,
    dataBaseAtividade,
    resolutionScreen,
    optionsHoras,
    optionsRetorno,
    dataBaseDev,
    optionsDesenvolvidosEstimados
} from "./index";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    BarElement,
    LineElement,
    Title,
    Tooltip,
    Legend
} from "chart.js";
import useAlert from "../../../services/useAlert";
import Select from "react-select";

ChartJS.register(
    Title,
    CategoryScale,
    LinearScale,
    BarElement,
    PointElement,
    LineElement,
    Tooltip,
    Legend
);

const SprintList = (props: any) => {

    const [loadingData, setLoandingDados] = useState(false);
    const initialValues: any = [];
    const [showAlert] = useAlert();
    const [dataResponseSprint, setData] = useState(initialValues);
    const [dadosAtividadeMembros, setDadosAtividadeMembros] = useState(initialValues);
    const [dataResponseSprintMembros, setDadosSprintMembros] = useState(initialValues);
    const [dataResponseAtividade, setDataAtividade] = useState(initialValues);
    const [dataLinearAtividade, setDataLinearAtividade] = useState({initialValues, datasets: []});
    const [dataLinearSprint, setDataLinearSprint] = useState({initialValues, datasets: []});
    const [dataLinearSprintDev, setDataLinearSprintDev] = useState({initialValues, datasets: []});
    const [dataAllTaksSprint, setDataAllTaksSprint] = useState(initialValues);
    const [dataAllAtividadeMember, setDataAllAtividadeMember] = useState(initialValues);
    const [afetado, setAfetado] = useState(true);
    const [visible1, setVisible1] = useState<number | null>(null);
    const [uptade, setUpdate] = useState(false);
    const [resultion, setResultion] = useState(false);
    const [indexI, setIndex] = useState<number | null>(0);
    const [showModal, setShowModal] = useState(false);
    const [showModalUser, setShowModalUser] = useState(false);
    const [dataResultLog, setDataResultLog] = useState(initialValues);
    const [rowEquals, setRowEquals] = useState<any>();
    const [listSprints, setListSprints] = useState<[]>([]);
    const [listTipoAtividade, setListTipoAtividade] = useState<[]>([]);
    const [valueFilterSprint, setValueFilterSprint] = useState<any[] | null>([]);
    const [valueFilterTipoAtividadeHorasExecucao, setValueTipoAtividadeHorasExecucao] = useState<any>([]);
    const [valueFilterTipoAtividadeRetornoQualidade, setValueTipoAtividadeRetornoQualidade] = useState<any>([]);
    const [valueFilterTipoAtividadeEstimadoDesenvolvido, setValueTipoAtividadeEstimadoDesenvolvido] = useState<any>([]);
    const [searchValue, setSearchValue] = useState("");
    const [nomeUser, setNomeUser] = useState('');
    const [orderRetornoAtividade, setOrderRetornoAtividade] = useState('desc');
    const [orderRetornoDesenvolvedor, setOrderRetornoDesenvolvedor] = useState('desc');

    const [loadingDataHorasExecucao, setLoadingDataHorasExecucao] = useState(true);
    const [loadingDataAtividadeRetorno, setLoadingDataAtividadeRetorno] = useState(true);
    const [loadingDatasEstimadoDesenvolvido, setLoadingDataEstimadoDesenvolvido] = useState(true);

    let var1 = -1;
    let var2 = -2;
    let var3 = -3;

    const loadingoff = () => {
        setUpdate(false);
    }
    useEffect(() => {
        setAfetado(true);
        setLoadingDataHorasExecucao(true);
        setLoadingDataAtividadeRetorno(true);
        setLoadingDataEstimadoDesenvolvido(true);
        if (afetado) {
            setUpdate(true);
            setResultion(resolutionScreen);
            getListTiposAtividade();
        }
    }, [afetado]);

    const updateData = () => {
        setAfetado(false)
    }

    const porcentagem = (parcial: any, total: any) => {

        if (parcial && total != 0) {
            return Math.round((parcial * 100) / total);
        } else {
            return 0;
        }

    }

    const getListSprints = (tipoAtividade: any) =>{
        let api = getApi();
        api.get(`get/list/sprints`).then((response) => {
            setListSprints(response.data)
            setValueFilterSprint(response.data[0])
            handleOptionSprint(tipoAtividade, response.data[0])
        });
    }

    const getListTiposAtividade = () =>{
        let api = getApi();
        api.get(`get/list/tipo-atividade`).then((response) => {
            setListTipoAtividade(response.data)
            setValueTipoAtividadeHorasExecucao(response.data[0])
            setValueTipoAtividadeRetornoQualidade(response.data[0])
            setValueTipoAtividadeEstimadoDesenvolvido(response.data[0])
            atualizaGraficoSprint(response.data[0]);
            atualizaGraficoAtividade(response.data[0]);
            getListSprints(response.data[0]);
        }).catch(() => {
            showAlert({
                title: 'Não foi possível acessar a requisição.',
                // @ts-ignore
                msg: error.toString(),
                toaster: false,
            });
        });
    }

    const horasMais = (horasTrabalhadas: any, horasEstimadas: any) => {
        return Math.round(horasEstimadas - horasTrabalhadas);
    }
    const atualizaGraficoAtividade = (option: any = null) => {
        setDataLinearAtividade(initialValues)
        let api = getApi();
        api.get(`retorno-atividade/list/` + option.value ?? 0).then((response) => {
            setDataAtividade(response.data)
            //@ts-ignore
            setDataLinearAtividade(dataBaseAtividade(response.data));
            loadingoff();
            setLoadingDataAtividadeRetorno(false)
        }).finally(()=>{
        }).catch(() => {
            showAlert({
                title: 'Não foi possível acessar a requisição.',
                // @ts-ignore
                msg: error.toString(),
                toaster: false,
            });
        });
    }

    const atualizaGraficoSprint = (option: any = null) => {
        setDataLinearSprint(initialValues)
        let api = getApi();
        api.get(`sprints/list/` + option.value ?? 0).then((response) => {
            setData(response.data)
            //@ts-ignore
            setDataLinearSprint(dataBaseSprint(response.data));
            loadingoff();
            setLoadingDataHorasExecucao(false)
        }).catch((error) => {
            showAlert({
                title: 'Não foi possível acessar a requisição.',
                // @ts-ignore
                msg: error.toString(),
                toaster: false,
            });
        });
    }

    const buscarSprintMembro = (sprint: any) => {
        setLoandingDados(true);
        let api = getApi();
        api.get(`busca-equipe/list/` + sprint).then((response) => {
            setDadosSprintMembros(response.data)
            setLoandingDados(false)
            loadingoff();
        }).catch((error) => {
            showAlert({
                title: 'Não foi possível acessar a requisição.',
                // @ts-ignore
                msg: error.toString(),
                toaster: false,
            });
        });
    }
    const buscarAtividadeMembro = (sprint: any, index: number, valueFilterTipoAtividade: any) => {
        if (rowEquals == index){
            return
        }
        setRowEquals(index);
        setLoandingDados(true);
        let api = getApi();
        api.get(`retorno-atividade-membro/list/` + sprint +`/`+ valueFilterTipoAtividade.value ?? 0).then((response) => {
            setDadosAtividadeMembros(response.data)
            setLoandingDados(false)
        }).catch((error) => {
            showAlert({
                title: 'Não foi possível acessar a requisição.',
                // @ts-ignore
                msg: error.toString(),
                toaster: false,
            });
        });
    }

    const buscarTodasAtividadesMembro = (idUser: number, nomeUser: string, optionTipoAtividade: any) =>{
        setDataAllAtividadeMember(null)
        setNomeUser(nomeUser)
        let api = getApi();
        //@ts-ignore
        api.get(`/get/tasks/member/` + idUser +'/'+ valueFilterSprint.value + `/` + optionTipoAtividade.value ?? 0).then((response) => {
            setDataAllAtividadeMember(response.data)
        })
        setShowModalUser(true)
    }

    const onClickDetalhes = (sprint: any, idUser: any, valueFilterTipoAtividade: any) => {
        let api = getApi();
        api.get(`detalhes/list/` + sprint + `/` + (valueFilterTipoAtividade.value ?? 0) + `?membro=` + idUser).then((response) => {
            setDataResultLog(response.data);
            setShowModal(true);
        }).finally(() => {

        });
    }

    const onCloseModal = () => {
        setShowModal(false);
        setShowModalUser(false);
    }

    const accordionAtividade = (index: number) => {
        setVisible1(visible1 == index ? null : index)
    }

    const AccordionDetalhes = (index: number) => {
        setIndex(indexI == index ? null : index)
    }

    const handleOptionSprint = (optionTipoAtividade: any, optionSprint: any)=>{
        setDadosSprintMembros(initialValues);
        setDataLinearSprintDev(initialValues);
        setDataAllTaksSprint(initialValues);
        atualizaDadosEstimadoDesenvolvido(optionSprint, optionTipoAtividade);
    }

    const handleOptionTipoAtividadeHorasExecucao = (option : any)=>{
        setValueTipoAtividadeHorasExecucao(option)
        atualizaGraficoSprint(option)
    }

    const handleOptionTipoAtividadeRetornoQualidade = (option : any)=>{
        setVisible1(null);
        setRowEquals(null);
        setDataAtividade(initialValues);
        setValueTipoAtividadeRetornoQualidade(option);
        atualizaGraficoAtividade(option);
    }

    const handleOptionTipoAtividadeEstimadoDesenvolvido = (optionSprint : any, optionTipoAtividade: any )=>{
        setDadosSprintMembros(initialValues);
        setDataLinearSprintDev(initialValues);
        setDataAllTaksSprint(initialValues);
        atualizaDadosEstimadoDesenvolvido(optionSprint, optionTipoAtividade);
    }

    const atualizaDadosEstimadoDesenvolvido = (optionSprint: any, optionTipoAtividade: any) => {
        let idSprint = optionSprint.value;
        let idTipoAtividade = optionTipoAtividade.value ?? 0;
        let api = getApi();
        api.get(`busca-equipe/list/` + idSprint + `/` + idTipoAtividade).then((response) => {
            //@ts-ignore
            setDataLinearSprintDev(dataBaseDev(response.data));
            setDadosSprintMembros(response.data);
            setLoadingDataEstimadoDesenvolvido(false)
        })
        api.get(`get/tasks/` + idSprint + `/` + idTipoAtividade).then((response) => {
            setDataAllTaksSprint(response.data);
        })
    }

    const atualizaDadosEstimadoAtividadeDesenvolvidoOrdenadoAtividade = (optionSprint: any, optionTipoAtividade: any, order: string) => {
        let isID = false
        if(!isNaN(Number(searchValue)) && searchValue.trim() !== ''){
            isID = true;
        }

        order === 'desc' ? order = 'asc' : order = 'desc';
        let idSprint = optionSprint.value;
        let idTipoAtividade = optionTipoAtividade.value ?? 0;
        let api = getApi();

        if(searchValue !== undefined && searchValue !== null) {
            api.get(`get/find/tasks/` + idSprint + `/` + idTipoAtividade + (isID ? `?id=` + searchValue : `?value=` + searchValue) + (order.length > 0 ? `&order=` + order: ``)).then((response) => {
                setDataAllTaksSprint(response.data);
            })
        }else{
            api.get(`get/tasks/` + idSprint + `/` + idTipoAtividade + (order.length > 0 ? `?order=` + order: ``)).then((response) => {
                setDataAllTaksSprint(response.data);
            })
        }
    }

    const atualizaDadosEstimadoDesenvolvidoOrdenadoDesenvolvedor = (optionSprint: any, optionTipoAtividade: any, order: string) => {
        order === 'desc' ? order = 'asc' : order = 'desc';
        let idSprint = optionSprint.value;
        let idTipoAtividade = optionTipoAtividade.value ?? 0;
        let api = getApi();
        api.get(`busca-equipe/list/` + idSprint + `/` + idTipoAtividade + (order.length > 0 ? `?order=` + order: ``)).then((response) => {
            //@ts-ignore
            setDataLinearSprintDev(dataBaseDev(response.data));
            setDadosSprintMembros(response.data);
        })
    }

    useEffect(() => {
        const timeout = setTimeout(() => {
            findTaskEstimadoDesenvolvido(searchValue, valueFilterSprint, valueFilterTipoAtividadeEstimadoDesenvolvido);
        }, 300);

        return () => clearTimeout(timeout);
    }, [searchValue, valueFilterSprint, valueFilterTipoAtividadeEstimadoDesenvolvido]);


    const findTaskEstimadoDesenvolvido = (value: any, optionSprint: any, optionTipoAtividade: any ) => {
        let isID = false
        if(!isNaN(Number(value)) && value.trim() !== ''){
             isID = true;
        }

        let idSprint = optionSprint.value;
        let idTipoAtividade = optionTipoAtividade.value ?? 0;
        let api = getApi();
        if(optionTipoAtividade !== undefined && optionTipoAtividade !== null && optionTipoAtividade.value !== undefined && optionTipoAtividade.value !== null){
            if (value != null && value.length > 0) {
                api.get(`get/find/tasks/` + idSprint + `/` + idTipoAtividade + (isID ? `?id=` + value : `?value=` + value)).then((response) => {
                    setDataAllTaksSprint(response.data);
                })
            }else{
                api.get(`get/tasks/` + idSprint + `/` + idTipoAtividade).then((response) => {
                    setDataAllTaksSprint(response.data);
                })
            }
        }
    }


    const formatarHoras = (valor: any) => {
        if (!valor) return '00:00';
        const numeroHoras = parseFloat(valor);
        if (isNaN(numeroHoras)) return '00:00';
        const horas = Math.floor(numeroHoras);
        const minutos = Math.round((numeroHoras - horas) * 60);
        return `${String(horas).padStart(2, '0')}:${String(minutos).padStart(2, '0')}`;
    };

    const teste = () =>{
        console.log('desc');
    }

    return (<div className={' w-100 mt-2'}>
            <div className={'flex-row text-right'}>
                <CButton className={'btn-info m-1 '} onClick={updateData}>
                    {uptade && <span className="spinner-border spinner-border-sm mr-2" role="status"
                                     aria-hidden="true"></span>}
                    Atualizar
                </CButton>
            </div>

            <div className={'bg-white w-100 mt-2 p-3'}>
                <div className={'m-3 card shadow-sm p-4 rounded-lg'}>
                    <div className="row bg-gray-200 ml-3 mr-3 mb-5 p-2 align-items-center">
                        <div className="col-md-9">
                            <h5 className="font-weight-bold text-dark mb-0">
                                Gráfico de Horas x Execução
                            </h5>
                        </div>
                        <div className="col-md-3 text-dark">
                            <div className="row">
                                <div className="col-md font-weight-bold d-flex flex-column justify-content-end align-items-end">
                                    <label className="mb-0">Tipo Tarefa:</label>
                                </div>
                                <div className="col-md-8">
                                    <Select
                                        isDisabled={loadingDataHorasExecucao}
                                        className=""
                                        options={listTipoAtividade}
                                        onChange={handleOptionTipoAtividadeHorasExecucao}
                                        value={valueFilterTipoAtividadeHorasExecucao}
                                        placeholder="Selecione o tipo de atividade"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={resultion ? '' : 'p-5 pt-lg-0 pb-lg-0 '}>
                        <Bar width="1200" height="350" options={optionsHoras} data={dataLinearSprint}></Bar>
                    </div>
                </div>
                <div className={'m-3 card shadow-sm p-4 rounded-lg'}>
                    <div className="row bg-gray-200 ml-3 mr-3 mb-5 p-2 align-items-center">
                        <div className="col-md-9">
                            <h5 className="font-weight-bold text-dark mb-0">
                                Gráfico de Atividades x Retornos Qualidade
                            </h5>
                        </div>
                        <div className="col-md-3 text-dark">
                            <div className="row">
                                <div className="col-md font-weight-bold d-flex flex-column justify-content-end align-items-end">
                                    <label className="mb-0">Tipo Tarefa:</label>
                                </div>
                                <div className="col-md-8">
                                    <Select
                                        isDisabled={loadingDataAtividadeRetorno}
                                        options={listTipoAtividade}
                                        onChange={handleOptionTipoAtividadeRetornoQualidade}
                                        value={valueFilterTipoAtividadeRetornoQualidade}
                                        placeholder="Selecione o tipo de atividade"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={resultion ? '' : 'p-5 pt-lg-0 pb-lg-0 '}>
                        <Bar width="1200" height="350" options={optionsRetorno} data={dataLinearAtividade}></Bar>
                    </div>
                    <div className={'text-muted execute-task-items col-md-12'}>
                        <br/>
                        <div className={"border-left font-lg border-right border-top mt-1 mb-3"}>
                            <div className="row m-0 bg-gray-200 p-2 ">
                                <div className={'col-11 cursor-pointer p-2 font-weight-bold text-dark mb-0 '}
                                     onClick={() => AccordionDetalhes(var2)}>Detalhes Atividades x Retornos Qualidade
                                </div>
                                <div onClick={() => AccordionDetalhes(var2)}
                                     className={'col-1 text-lg-right cursor-pointer font-weight-bold '}>
                                    <CIcon name="cilChevronCircleDownAlt"></CIcon></div>
                            </div>
                            <div className='border-bottom'/>
                            <CCollapse className={'collapse-var2'} show={indexI == var2}>
                                <div>
                                    <CRow>
                                        <div className="col-12">
                                            <div className="row font-weight-bold border-bottom m-0">
                                                <div className={resultion ? 'text-center col p-2 pt-4' : 'p-2 col'}>
                                                    Sprint
                                                </div>
                                                <div
                                                    className={resultion ? 'p-2 col border-left text-center pt-4' : 'p-2 col border-left text-center'}>
                                                    Total de Atividades
                                                </div>
                                                <div
                                                    className={resultion ? 'col border-left text-center pt-4' : 'p-2 col border-left text-center'}>
                                                    Total de Atividades Retornadas
                                                </div>
                                                <div
                                                    className={resultion ? 'col border-left text-center pt-4' : 'p-2 col border-left text-center'}>
                                                    Índice Retorno
                                                </div>
                                            </div>
                                        </div>
                                    </CRow>
                                    {dataResponseAtividade.map((result: any, index: number) => (
                                        <div key={index}>
                                            <div className={'detalhes-retorno-atividade'} key={index} color="primary"
                                                 onClick={() => accordionAtividade(index)}>
                                                <div
                                                    className={"text-hover-sprints row border-bottom m-0 cursor-pointer"}
                                                    onClick={() => buscarAtividadeMembro(result['sprint'], index, valueFilterTipoAtividadeRetornoQualidade)}>
                                                    <div className={'col d-flex'}>
                                                        <div className={'pt-2 '}>
                                                            {result['sprint']}
                                                        </div>
                                                    </div>
                                                    <div className={'col text-center border-left'}>
                                                        {result['total']}
                                                    </div>
                                                    <div className={' col text-center border-left'}>
                                                        {result['totalRetorno']}&nbsp;
                                                        ({porcentagem(result['totalRetorno'], result['total'])}%)
                                                    </div>
                                                    <div className={'col text-center border-left'}>
                                                        {result['indiceRetorno'] != null && !isNaN(result['indiceRetorno'])
                                                            ? parseFloat(result['indiceRetorno']).toLocaleString('pt-BR', {
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 2
                                                            })
                                                            : 'N/A'}
                                                    </div>
                                                </div>
                                            </div>
                                            <CCollapse className={'border-bottom pb-4 pt-4'} show={visible1 == index}>
                                                <div className="col-12 p-0">
                                                <div className={loadingData ? " spinner-border" : ""}></div>
                                                    {!loadingData &&
                                                        <div className="col-12 p-0 ">
                                                            {dadosAtividadeMembros && dadosAtividadeMembros.map((membro: any, indexMembro: number) => (
                                                                <div
                                                                    className={((indexMembro % 2) === 0) ? 'row m-0 detalhes  bg-light' : 'row  m-0 detalhes'}
                                                                    key={indexMembro}>
                                                                    <div
                                                                        className="text-hover col-12 align-content-around"
                                                                        onClick={() => onClickDetalhes(result['sprint'], membro['id_membro'], valueFilterTipoAtividadeRetornoQualidade)}
                                                                        key={indexMembro}>
                                                                        <div
                                                                            className={" row cursor-pointer"}>
                                                                            <div
                                                                                className={resultion ? 'col overflow-hidden border-right' : " col text-left  border-right"}>
                                                                                {membro.nome}
                                                                            </div>
                                                                            <div className="col text-center ">
                                                                                {membro.taskTotais}
                                                                            </div>
                                                                            <div
                                                                                className="col text-center border-left">
                                                                                {membro.taskRecusadas ? membro.taskRecusadas : 0}
                                                                                &nbsp;({porcentagem(membro.taskRecusadas, membro.taskTotais)}%)
                                                                            </div>
                                                                            <div
                                                                                className="col text-center border-left">
                                                                                {typeof membro.indiceRetorno === 'number'
                                                                                    ? membro.indiceRetorno.toLocaleString('pt-BR', {
                                                                                        minimumFractionDigits: 2,
                                                                                        maximumFractionDigits: 2
                                                                                    })
                                                                                    : parseFloat(membro.indiceRetorno).toLocaleString('pt-BR', {
                                                                                        minimumFractionDigits: 2,
                                                                                        maximumFractionDigits: 2
                                                                                    })}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    }
                                                </div>
                                            </CCollapse>
                                        </div>
                                    ))}
                                </div>
                            </CCollapse>
                        </div>
                    </div>
                </div>
                <div className="m-3 card shadow-sm p-4 rounded-lg">
                    <div className="row bg-gray-200 ml-3 mr-3 p-2 align-items-center">
                        <div className="col-md-6">
                            <h5 className="font-weight-bold text-dark mb-0">
                                Estimado x Desenvolvido (h)
                            </h5>
                        </div>
                        <div className="col-md-3 text-dark">
                            <Select
                                isDisabled={loadingDatasEstimadoDesenvolvido}
                                className=""
                                options={listSprints}
                                onChange={(selectedOption) => {
                                    setValueFilterSprint(selectedOption);
                                    handleOptionSprint(valueFilterTipoAtividadeEstimadoDesenvolvido, selectedOption);
                                }}
                                value={valueFilterSprint}
                                placeholder="Selecione a Sprint"
                            />
                        </div>
                        <div className="col-md-3 text-dark">
                            <div className="row">
                                <div className="col-md font-weight-bold d-flex flex-column justify-content-end align-items-end">
                                    <label className="mb-0">Tipo Tarefa:</label>
                                </div>
                                <div className="col-md-8">
                                    <Select
                                        isDisabled={loadingDatasEstimadoDesenvolvido}
                                        className=""
                                        options={listTipoAtividade}
                                        onChange={(selectedOption) => {
                                            setValueTipoAtividadeEstimadoDesenvolvido(selectedOption);
                                            handleOptionTipoAtividadeEstimadoDesenvolvido(valueFilterSprint, selectedOption);
                                        }}
                                        value={valueFilterTipoAtividadeEstimadoDesenvolvido}
                                        placeholder="Selecione o tipo de atividade"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`chart-container mt-3 ${resultion ? '' : 'p-5 pt-lg-0 pb-lg-0'}`}>
                        <Bar
                            width={1200}
                            height={350}
                            options={optionsDesenvolvidosEstimados}
                            data={dataLinearSprintDev}
                        />
                    </div>
                    <div className={'text-muted execute-task-items col-md-12'}>
                        <br/>
                        <div className={"border-left font-lg border-right border-top mt-1 mb-3"}>
                            <div className="row m-0 bg-gray-200 p-2 ">
                                <div className={'col-11 cursor-pointer p-2 font-weight-bold text-dark mb-0 '}
                                     onClick={() => AccordionDetalhes(var1)}>Estimado x Desenvolvido (Desenvolvedor)
                                </div>
                                <div onClick={() => AccordionDetalhes(var1)}
                                     className={'col-1 text-lg-right cursor-pointer font-weight-bold '}>
                                    <CIcon name="cilChevronCircleDownAlt"></CIcon></div>
                            </div>
                            <div className='border-bottom'/>
                            <CCollapse className={'collapse-var2'} show={indexI == var1}>
                                <div>
                                    <CRow>
                                        <div className="col-12">
                                            <div className="row font-weight-bold border-bottom m-0">
                                                <div className={resultion ? 'text-center col p-2 pt-4' : 'p-2 col'}>
                                                    Nome
                                                </div>
                                                <div
                                                    className={resultion ? 'p-2 col border-left text-center pt-4' : 'p-2 col border-left text-center'}>
                                                    Total Horas Estimadas
                                                </div>
                                                <div
                                                    className={resultion ? 'col border-left text-center pt-4' : 'p-2 col border-left text-center'}>
                                                    Total Horas Executadas
                                                </div>
                                                <div
                                                    onClick={()=>{
                                                        setOrderRetornoDesenvolvedor(orderRetornoDesenvolvedor === 'asc' ? 'desc' : 'asc');
                                                        atualizaDadosEstimadoDesenvolvidoOrdenadoDesenvolvedor(valueFilterSprint, valueFilterTipoAtividadeEstimadoDesenvolvido, orderRetornoDesenvolvedor);
                                                    }}
                                                    className={resultion ? 'col border-left text-center p-4 ' : 'p-2 col border-left text-center cursor-pointer'}>
                                                    <div className={'row'}>
                                                        <div className={'col-md-10'}>
                                                            Percentual Diferença
                                                        </div>
                                                        <div className={'col-md mr-1'}>
                                                            {orderRetornoDesenvolvedor === 'desc' ? <CIcon name="cilArrowBottom"></CIcon> : <CIcon name="cilArrowTop"></CIcon>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </CRow>
                                    {dataResponseSprintMembros.map((result: any, index: number) => (
                                        <div key={index}>
                                            <div className={'detalhes-retorno-atividade'} key={index} color="primary">
                                                <div
                                                    className={"text-hover-sprints row border-bottom m-0 cursor-pointer"}
                                                    onClick={() => buscarTodasAtividadesMembro(result['userId'], result['nome'], valueFilterTipoAtividadeEstimadoDesenvolvido)}>
                                                    <div className={'col d-flex'}>
                                                        <div className={'pt-2 '}>
                                                            {result?.nome}
                                                        </div>
                                                    </div>
                                                    <div className={'col text-center border-left'}>
                                                        {formatarHoras(result?.totalHorasEstimadas)}
                                                    </div>
                                                    <div className={' col text-center border-left'}>
                                                        {formatarHoras(result?.totalHorasExecucao)}
                                                    </div>
                                                    <div className={'col text-center border-left'}>
                                                        {result?.percentualDiferenca}%
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </CCollapse>
                        </div>
                    </div>

                    <div className={'text-muted execute-task-items col-md-12'}>
                        <br/>
                        <div className={"border-left font-lg border-right border-top mt-1 mb-3"}>
                            <div className="row m-0 bg-gray-200 p-2 ">
                                <div className={'col-md-8 cursor-pointer p-2 font-weight-bold text-dark mb-0 '}
                                     onClick={() => AccordionDetalhes(var3)}>Estimado x Desenvolvido (Atividades)
                                </div>
                                <div className="col-md-3 text-dark">

                                    <CInput
                                        disabled={loadingDatasEstimadoDesenvolvido}
                                        type="text"
                                        id="find-task"
                                        name="find-task"
                                        placeholder="Pesquisar por nome da atividade ou ID"
                                        maxLength={120}
                                        onChange={(e: any) => setSearchValue(e.target.value)}
                                    />
                                </div>

                                <div onClick={() => AccordionDetalhes(var3)}
                                     className={'col-1 text-lg-right cursor-pointer font-weight-bold '}>
                                    <CIcon name="cilChevronCircleDownAlt"></CIcon></div>
                            </div>
                            <div className='border-bottom'/>
                            <CCollapse className={'collapse-var2'} show={indexI == var3}>
                                <div>
                                    <CRow>
                                        <div className="col-12">
                                            <div className="row font-weight-bold border-bottom m-0">
                                                <div className={resultion ? 'text-center col-7 p-2 pt-4' : 'p-2 col-5'}>
                                                    Atividade
                                                </div>
                                                <div
                                                    className={resultion ? 'p-2 col border-left text-center pt-4' : 'p-2 col border-left text-center'}>
                                                    Total Horas Estimadas
                                                </div>
                                                <div
                                                    className={resultion ? 'col border-left text-center pt-4' : 'p-2 col border-left text-center'}>
                                                    Total Horas Executadas
                                                </div>
                                                <div
                                                    className={resultion ? 'col border-left text-center pt-4' : 'p-2 col border-left text-center'}>
                                                    Diferença (horas)
                                                </div>
                                                <div
                                                    onClick={()=>{
                                                        setOrderRetornoAtividade(orderRetornoAtividade === 'asc' ? 'desc' : 'asc');
                                                        atualizaDadosEstimadoAtividadeDesenvolvidoOrdenadoAtividade(valueFilterSprint, valueFilterTipoAtividadeEstimadoDesenvolvido, orderRetornoAtividade);
                                                    }}
                                                    className={resultion ? 'col border-left text-center p-4 ' : 'p-2 col border-left text-center cursor-pointer'}>
                                                    <div className={'row'}>
                                                        <div className={'col-md-10'}>
                                                            Percentual Diferença
                                                        </div>
                                                        <div className={'col-md mr-1'}>
                                                            {orderRetornoAtividade === 'desc' ? <CIcon name="cilArrowBottom"></CIcon> : <CIcon name="cilArrowTop"></CIcon>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </CRow>



                                    {dataAllTaksSprint?.map((result: any, index: number) => (
                                        <div key={index}>
                                            <div className={((index % 2) === 0) ? 'detalhes-retorno-atividade  bg-light' : 'detalhes-retorno-atividade'} key={index} color="primary">
                                                <div
                                                    className={"row border-bottom m-0"}>
                                                    <div className={'col-5 d-flex'}>
                                                        <div className={'pt-2 '}>
                                                            <a href={`https://redmine.panoramasistemas.com.br/issues/${result.idAtividade}`}
                                                               target="_blank">#{result?.['idAtividade']} - <strong>{result?.tituloAtividade}</strong></a>
                                                        </div>
                                                    </div>
                                                    <div className={'col text-center border-left'}>
                                                        {formatarHoras(result?.horasEstimadas)}
                                                    </div>
                                                    <div className={'col text-center border-left'}>
                                                        {formatarHoras(result?.horasExecutadas)}
                                                    </div>
                                                    <div className={'col text-center border-left'}>
                                                        {formatarHoras(result?.diferenca)}
                                                    </div>
                                                    <div className={'col text-center border-left'}>
                                                        {result?.percentualAtividade}%
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <div className={'float-right'}>Total: {dataAllTaksSprint.length}</div>
                            </CCollapse>
                        </div>
                    </div>
                </div>
            </div>

            <div className={'p-4'}/>
            <CModal
                show={showModal}
                onClosed={onCloseModal}
                backdrop={true}
                color="info"
                size={'lg'}
            >
                <CModalHeader closeButton>
                    {dataResultLog.length > 0 && (
                        <CModalTitle className={"col-10"}>Detalhes Tasks
                            #{dataResultLog[0]['destino']}
                            <p className={'col-3 float-right text-sm-right font-italic font-sm'}>Sprint
                                #{dataResultLog[0]['name']}</p></CModalTitle>)}
                </CModalHeader>
                <CModalBody>
                    <div className={'row border-bottom border-top'}>
                        <div className={"col-3 text-center pt-1"} aria-hidden={true}>
                            Task
                        </div>
                        <div className={"p-2 col-3  border-left text-center pt-1"} aria-hidden={true}>
                            Quem Rejeitou
                        </div>
                        <div className={"p-2 col-3 border-left text-center pt-1"} aria-hidden={true}>
                            Vezes Rejeitada
                        </div>
                        <div className={"p-2 col-3 border-left text-center pt-1"} aria-hidden={true}>
                            Horas Trabalhadas
                        </div>
                    </div>
                    {dataResultLog.map((result: any, index: number) => (
                            <div
                                className={((index % 2) === 0) ? 'row border-bottom border-0 detalhes bg-gray-100' : 'row border-bottom detalhes'}
                                key={index}>
                                <div className={"col-3 text-center pt-1"} aria-hidden={true}>
                                    <a href={`https://redmine.panoramasistemas.com.br/issues/${result.id_issue}`}
                                       target="_blank">#{result['id_issue']}</a>
                                </div>
                                <div className={" col-3 border-left"} aria-hidden={true}>
                                    {result['user_origem']}
                                </div>
                                <div className={" col-3 border-left"} aria-hidden={true}>
                                    {result['amount_recused']}
                                </div>
                                <div className={" col-3 border-left text-center text-hidden"} aria-hidden={true}>
                                    {result['horas_trabalhadas'] ! ? parseFloat(result['horas_trabalhadas']).toFixed(2) : 0}
                                </div>
                            </div>
                        )
                    )}
                </CModalBody>
            </CModal>

            <CModal
                show={showModalUser}
                onClosed={onCloseModal}
                backdrop={true}
                color="info"
                size={'xl'}
            >
                <CModalHeader closeButton>
                    {nomeUser.length > 0 && (
                        <CModalTitle className={"col-10"}>
                            Detalhes Tasks - {nomeUser}
                        </CModalTitle>
                    )}
                </CModalHeader>
                <CModalBody>
                    <div className={'row border-bottom border-top'}>
                        <div className={"col-8 text-center pt-1"} aria-hidden={true}>
                            Atividade
                        </div>
                        <div className={"p-2 col-1  border-left text-center pt-1"} aria-hidden={true}>
                            Estimado (h)
                        </div>
                        <div className={"p-2 col-1 border-left text-center pt-1"} aria-hidden={true}>
                            Executado (h)
                        </div>
                        <div className={"p-1 col-1 border-left text-center pt-1"} aria-hidden={true}>
                            Diferença (h)
                        </div>
                        <div className={"p-2 col-1 border-left text-center pt-1"} aria-hidden={true}>
                            Percentual Diferença
                        </div>
                    </div>
                    {dataAllAtividadeMember?.map((result: any, index: number) => (
                        <div className={((index % 2) === 0) ? 'row border-bottom border-0 detalhes bg-gray-100' : 'row border-bottom detalhes'} key={index}>
                                <div className={"col-8 pt-1"} aria-hidden={true}>
                                    <a href={`https://redmine.panoramasistemas.com.br/issues/${result.idAtividade}`}
                                       target="_blank">#{result?.['idAtividade']} - <strong>{result?.tituloAtividade}</strong></a>
                                </div>
                                <div className={"col-1 border-left"} aria-hidden={true}>
                                    {formatarHoras(result?.['horasAtividade'])}
                                </div>
                                <div className={"col-1 border-left"} aria-hidden={true}>
                                    {formatarHoras(result?.['horasExecutadas'])}
                                </div>
                                <div className={"col-1 border-left text-center text-hidden"} aria-hidden={true}>
                                    {formatarHoras(result?.['diferenca'])}
                                </div>
                                <div className={"col-1 border-left text-center text-hidden"} aria-hidden={true}>
                                    {result?.['percentualAtividade']}%
                                </div>
                            </div>
                        )
                    )}
                </CModalBody>
            </CModal>

        </div>
    );
};
export default SprintList;